import { useEffect, useRef } from "react";
import { sendAnalytics } from "../helpers/xhr";
import { AnalyticIngestEvent, ProductMetaData } from "../types/Analytics";
import {
  getOrCreateSessionId,
  getOrCreateVisitorId,
} from "../helpers/analytics/events";

type Prop = {
  page: string;
  meta?: ProductMetaData;
};

const useAnalytics = (props: Prop) => {
  // const startTimeRef = useRef<number>(Date.now());
  const visitorId = useRef(getOrCreateVisitorId());
  const sessionId = useRef(getOrCreateSessionId());
  // todo: consider using getScrollDepth() from helpers/analytics
  useEffect(() => {
    const visitorIdValue = visitorId.current;
    const sessionIdValue = sessionId.current;
    const startTime = Date.now();

    return () => {
      const endTime = Date.now();
      const visibleTime = endTime - startTime;

      const event: AnalyticIngestEvent = {
        tenantId: 1,
        eventType: "page_view",
        page: props.page,
        timestamp: endTime,
        visitorId: visitorIdValue,
        sessionId: sessionIdValue,
        pageMetrics: { visibleTime },
        meta: props.meta,
      };

      sendAnalytics(event).catch(() => {});
    };
  }, [props.page, props.meta]);
};

export default useAnalytics;
